import { Navigate, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import {
  Breadcrumbs,
  Flex,
  FlexColumn,
  FlexSpace,
  GenerateAIButton,
} from '@elementary/common-ui/components';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import { IncidentOverviewSidePanel } from 'incidents/components/IncidentOverviewSidePanel';
import {
  IncidentOverviewSidePanel as IncidentOverviewSidePanelV2,
  IncidentTable as IncidentTableV2,
} from 'incidents/incident-v2';
import MergeIncidentsPage from 'incidents/incident-v2/MergeIncidentsPage';
import IncidentSettingsMenu from 'incidents/incident-v2/components/IncidentSettingsMenu';
import useJiraProjectFields from 'shared/components/ticketing/useJiraProjectFields';
import IncidentTable from './IncidentTable';

const Wrapper = styled(FlexColumn)`
  padding: 24px 24px 0 24px;
  gap: 24px;
  overflow: hidden;
  height: 100%;
  min-width: 930px;
`;

const Incidents = () => {
  const envId = useSelectedEnv();
  const { data: account } = useAccount();
  const useV2 = account?.incidents_v2_enabled;
  useJiraProjectFields(envId);

  return (
    <Routes>
      <Route
        path="merge"
        element={
          useV2 ? (
            <MergeIncidentsPage />
          ) : (
            <Navigate to={`/${envId}/incidents`} replace />
          )
        }
      />
      <Route
        index
        element={
          <>
            <Wrapper>
              <FlexSpace>
                <Breadcrumbs items={['Response & Triage', 'Incidents']} />
                <Flex sx={{ gap: 1, alignItems: 'center' }}>
                  {account?.ai_features_enabled && (
                    <GenerateAIButton>Manage incidents</GenerateAIButton>
                  )}
                  {useV2 ? <IncidentSettingsMenu /> : null}
                </Flex>
              </FlexSpace>
              {useV2 ? <IncidentTableV2 /> : <IncidentTable />}
            </Wrapper>
            {useV2 ? (
              <IncidentOverviewSidePanelV2 />
            ) : (
              <IncidentOverviewSidePanel />
            )}
          </>
        }
      />
    </Routes>
  );
};

export default Incidents;
